<script setup lang="ts">
	interface NavigationItem {
		label: string,
		name: string,
		slug?: string
	}
	export type {
		NavigationItem
	}

	const $props = defineProps<{
		items: Array<NavigationItem>,
	}>()
</script>

<template>
	<nav aria-label="Hauptnavigation" class="my-auto" role="navigation">
		<span v-if="items?.length"
			  class="flex flex-row justify-end lg:space-x-2 xl:space-x-3 mx-5">
			<span v-for="(item,idx) in items" :key="idx">
				<NuxtLink
					:title="`zur Seite ${item.label}`"
					:to="{name: item.name, params: item.slug ? { article_slug: item.slug } : {}}" class="px-3 text-xl text-black hover:text-red focus:text-red whitespace-nowrap transition duration-300 ease-in-out"
					no-prefetch>
					{{ item.label }}
				</NuxtLink>
			</span>
		</span>
	</nav>
</template>
